// extracted by mini-css-extract-plugin
export default {"stack":"OvAOQhCV6es4O4DFnp2R","save-toolbar":"VYM14i99DKgMnzfVpn5g","icon":"VLslnwYp4IpKoJV_Segz"};